export const apiUrl = 'https://gateway.pisen.com.cn';
export const baseUrl = `${apiUrl}/api/qjw.user2.api`;
export const appKey = '1871672';
export const appSecret = 'c8e9a15f63407c2d5435434yuyjjghrtb';
export const basePath = '/mobile/';
export const tel = '4000889898';
export const wechatAppId = 'wx96508594bd2246a9';

export const promotionUrl = 'https://m.3ceasy.com/fx/Merchant/MyPromotion';

export const ContactUs = '470028321667551232';
export const AboutUs = '470027955257348096';
export const FAQ = '470028581848616960';
export const WarefareADLevel = '505853268247580672';
export const HomeBannerADLevel = '581973602516471808';
export const HomeHotADLevel = '581973672246775808';

export const CF_CouponChannel = 2;
export const defaultServeUrl =
  'https://webchat-bj.tinetcloud.com/chat.html?accessId=b86dd8fc-6fdb-41ad-954f-c26a8a10d77b&language=zh_CN';
export const servicingOrdersServeUrl =
  'https://webchat-bj.tinetcloud.com/chat.html?accessId=52fc15e9-1964-4e5c-bc0e-23b0b0df8660&language=zh_CN';
export const scanServeUrl =
  'https://webchat-bj.tinetcloud.com/chat.html?accessId=720a1e94-ed49-47bb-bf17-f0f7c4199274&language=zh_CN';
export const storesServeUrl =
  'https://webchat-bj.tinetcloud.com/chat.html?accessId=f5d02bc1-2b96-40b3-85e2-2b0713b6f889&language=zh_CN';
export const storeListUrl = 'https://r.piseneasy.com/DrdMapStoreQjw/Store/List';
